import { useNavigate } from 'react-router-dom';
import ProductListPanel from '../../components/products/ProductListPanel';
import { buildTradePath } from '@formosa/shared/utils/productNavigation';

export default function ProductsPage({ title = '全部產品', showClose = true }) {
  const navigate = useNavigate();

  function handleProductClick(product, playType) {
    navigate(buildTradePath(playType || product.playType, product.marketSymbolCode));
  }

  return (
    <ProductListPanel
      title={title}
      showClose={showClose}
      onClose={() => navigate(-1)}
      onProductClick={handleProductClick}
      initialTab="timed"
    />
  );
}
